import Transform from '@app/transformers';
import * as TransferItemsHelper from '@app/helper/transfer-items';

export const getTransfer = () => {
  const sideloaded = window['__session__'] || {};
  const auth = Transform.auth(sideloaded.user);
  const accountId = auth.account.id;

  // initial Transfer state
  return {
    files: [],
    items: [],
    itemsTree: TransferItemsHelper.buildItemsTree(),
    sender: '',
    message: '',
    recipients: [],
    accountId,
  };
};

export default getTransfer();
